import React from 'react';
import { FadeIn } from './ui/FadeIn';
const steps = [{
  num: '1',
  title: 'Identifica',
  desc: 'Usa nuestra guía para saber en qué fase de tu ciclo estás hoy.'
}, {
  num: '2',
  title: 'Sincroniza',
  desc: 'Ajusta tu rutina de ejercicios y alimentación según tu fase actual.'
}, {
  num: '3',
  title: 'Drena',
  desc: 'Mira cómo la inflamación desaparece y tu fuerza real emerge en el espejo.'
}];
export function HowItWorksSection() {
  return <section className="py-24 bg-emerald-950 relative border-t border-emerald-800/30" data-id="element-89">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-90">
        <FadeIn data-id="element-91">
          <h2 className="text-3xl md:text-5xl font-bold mb-16 text-center" data-id="element-92">
            CÓMO <span className="text-gradient-gold" data-id="element-93">FUNCIONA</span>
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-94">
          {/* Desktop connecting line */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-emerald-800/50 z-0" data-id="element-95" />

          {steps.map((step, index) => <FadeIn key={index} delay={0.1 * index} className="relative z-10" data-id="element-96">
              <div className="flex flex-col items-center text-center" data-id="element-97">
                <div className="w-24 h-24 rounded-full bg-emerald-900 border-2 border-gold-500/30 flex items-center justify-center mb-6 shadow-[0_0_30px_rgba(212,175,55,0.1)]" data-id="element-98">
                  <span className="text-4xl font-heading font-bold text-gold-400" data-id="element-99">
                    {step.num}
                  </span>
                </div>
                <h3 className="text-2xl font-bold mb-4 text-white" data-id="element-100">
                  {step.title}
                </h3>
                <p className="text-emerald-100/70 font-body leading-relaxed max-w-xs" data-id="element-101">
                  {step.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}